const BACKEND_URL = window.location.origin;

export const getImageUrl = (src) => {
  if (!src) return '';
  return src.startsWith('http') ? src : `${BACKEND_URL}${src}`;
};

export const productImageProps = (src, alt, { priority = false, size = 'card' } = {}) => {
  const url = getImageUrl(src);
  const sizes = size === 'detail'
    ? '(max-width: 768px) 100vw, 50vw'
    : size === 'thumb'
      ? '80px'
      : '(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw';

  return {
    src: url,
    alt: alt || '',
    loading: priority ? 'eager' : 'lazy',
    decoding: priority ? 'sync' : 'async',
    sizes,
    ...(priority ? { fetchpriority: 'high' } : {}),
  };
};
